import React, { useContext } from 'react';

import styled from '@emotion/styled';

import CloseIcon from '../Icons/CloseIcon';
import { ModalContext } from '../Modal/ModalContext';

interface PdfPreviewerModalProps {
  docUrl: string;
}
const PdfPreviewerModal: React.FC<PdfPreviewerModalProps> = ({ docUrl }) => {
  const modalContext = useContext(ModalContext);
  const onClickCancel = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    modalContext?.setShowModal(false);
  };

  return (
    <Container
      // className='no-click-record'
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <IconContainer
        onClick={
          // onClickCancel
          (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            e.stopPropagation();
            onClickCancel(e);
          }
        }
      >
        <CloseIconStyle>
          <CloseIcon />
        </CloseIconStyle>
      </IconContainer>

      <PdfArea>
        <Pdf src={docUrl} title='PDF Document' />
      </PdfArea>
    </Container>
  );
};

export default PdfPreviewerModal;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
  flex-direction: column;
  width: 620px;
  gap: 20px;
`;

const IconContainer = styled.div`
  cursor: pointer;
  align-self: flex-end;

  transform: scale(100%);
  transition: transform 0.3s ease-out;

  &:hover {
    transform: scale(110%);
  }
`;

const PdfArea = styled.div`
  display: grid;
  width: 620px;
  height: 700px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5;
`;

const Pdf = styled.iframe`
  display: flex;
  width: 100%;
  height: 100%;
  border: none;
`;

const CloseIconStyle = styled.div`
  background-color: white;
  border-radius: 50%;
  padding: 6px;
`;
